/**
 * AppICEMAP — Comments API
 * Fetch and create report comments from Directus.
 */

import { getClient, readItems, createItem } from "./directus.js";

const COMMENTS_COLLECTION = "comments";

/**
 * Fetch comments for a report, sorted chronologically.
 * @param {string} reportId
 * @param {{ limit?: number }} [options]
 * @returns {Promise<Array>}
 */
export async function fetchComments(reportId, options = {}) {
	const client = getClient();
	const { limit = 100 } = options;

	try {
		const result = await client.request(
			readItems(COMMENTS_COLLECTION, {
				fields: [
					"id",
					"report",
					"user.id",
					"user.first_name",
					"user.last_name",
					"user.avatar",
					"body",
					"parent",
					"created_at",
					"updated_at",
				],
				filter: {
					report: { _eq: reportId },
				},
				sort: "created_at",
				limit,
			}),
		);
		return result || [];
	} catch (err) {
		console.error("[API] fetchComments error:", err);
		return [];
	}
}

/**
 * Create a comment on a report.
 * @param {{ report: string, body: string, parent?: string }} payload
 * @returns {Promise<object>}
 */
export async function createComment(payload) {
	const client = getClient();

	try {
		const result = await client.request(
			createItem(COMMENTS_COLLECTION, payload),
		);
		return result;
	} catch (err) {
		console.error("[API] createComment error:", err);
		throw err;
	}
}
